module.exports = __webpack_public_path__ + "static/img/sign2.34c7dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/sign2.png
// module id = O3el
// module chunks = 36